import {Box, Flex, Text} from "@chakra-ui/react";
import Chart from "react-apexcharts";
import {BsCircleFill} from "react-icons/bs";
import React from "react";
import {indexColorMap} from "./SentimentSelectorButton";

export default function SentimentAnalysisBar(props) {
    // TODO: Make the left hand side bar be rounded as well for symmetry
    let {series, maxWidth, maxSum} = props;
    const sum = series[0]["data"][0] + series[1]["data"][0] + series[2]["data"][0]
    let width = sum * maxWidth / maxSum;
    const options = {
        chart: {
            type: 'bar',
            height: 50,
            width: width,
            stacked: true,
            toolbar: {
                show: false
            },
            sparkline: {
                enabled: true
            },
            offsetY: 0,
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 5
            },
        },
        colors: [indexColorMap[0], indexColorMap[1], indexColorMap[2]],
        stroke: {
            width: 1,
            colors: ['#fff']
        },

        tooltip: {
            enabled: true,
            x: {
                show: false
            },
            y: {
                formatter: function (value, others) {
                    return value;
                }
            }
        },
    }
    return (
        <>
            <Box w='500px'>
                <Box>
                    <Flex flexDirection='row'>
                        <span style={{display: 'inline-flex', alignItems: 'center'}}>
                            <BsCircleFill
                                style={{color: indexColorMap[0], size: "1em", margin: "3px"}}/>
                            <Text>{(100 * series[0]["data"][0] / sum).toFixed(0)}% ({series[0]["data"][0]})</Text>
                        </span>
                        <span style={{display: 'inline-flex', alignItems: 'center', marginLeft: '10px'}}>
                            <BsCircleFill
                                style={{color: indexColorMap[1], size: "1em", margin: "3px"}}/>
                            <Text>{(100 * series[1]["data"][0] / sum).toFixed(0)}% ({series[1]["data"][0]})</Text>
                        </span>
                        <span style={{display: 'inline-flex', alignItems: 'center', marginLeft: '10px'}}>
                            <BsCircleFill
                                style={{color: indexColorMap[2], size: "1em", margin: "3px"}}/>
                            <Text>{(100 * series[2]["data"][0] / sum).toFixed(0)}% ({series[2]['data'][0]})</Text>
                        </span>
                    </Flex>
                </Box>
                <div className="sentimentBarChart" w='400px'>
                    <Chart options={options} series={series} type="bar" height={20}
                           width={width}/>
                </div>
            </Box>
        </>
    )
}